export const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL';
export const GET_ORDER_DETAIL_SUCCESS = 'GET_ORDER_DETAIL_SUCCESS';
export const GET_ORDER_DETAIL_ERROR = 'GET_ORDER_DETAIL_ERROR';
export const GET_ORDER_DETAIL_LOADING_STOP = 'GET_ORDER_DETAIL_LOADING_STOP';
export const SET_LOADER = 'SET_LOADER';
